"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logLevel = exports.defaultPTSFrequency = void 0;
exports.defaultPTSFrequency = 90000;
exports.logLevel = {
    CLIENT: 'CLIENT',
    HTTP: 'HTTP',
    SDK: 'SDK',
    WS: 'WS'
};
//# sourceMappingURL=constants.js.map